export interface SchdMessage {
  flagRicInConfigMode: boolean // true = RIC configuration mode
  flagInScheduleStartupMode: boolean // true = message/3min, false = message/15min
  flagPowerIsBelowShutdownLevel: boolean // below 3.0V
  flagPowerIsBelowWarningLevel: boolean // below 3.25V
  temperature: number // 2 modes: internal temp, weather station mode (value is 7.5 fixed point with 0x000 = -40C, range is -40C to +85C)
  sensorReadings: { [key: string]: number }
}
export type SensorReadings = { [key: string]: number }

// Schd = Scheduled Reading
export function decodeSchdMessage(data: Uint8Array): SchdMessage {
  const statusFlag = data[0] >> 4
  const flagRicInConfigMode = !!(statusFlag & 0x80)
  const flagInScheduleStartupMode = !!(statusFlag & 0x40)
  const flagPowerIsBelowShutdownLevel = !!(statusFlag & 0x20)
  const flagPowerIsBelowWarningLevel = !!(statusFlag & 0x10)

  const temperature = ((data[0] & 0x0f) << 8) | data[1] // 7.5 fixed point format

  const sensorReadings: SensorReadings = {
    A1: (data[2] << 4) | ((data[3] & 0xf0) >> 4),
    A2: ((data[3] & 0x0f) << 8) | data[4],
    B1: (data[5] << 4) | ((data[6] & 0xf0) >> 4),
    B2: ((data[6] & 0x0f) << 8) | data[7],
    C1: (data[8] << 4) | ((data[9] & 0xf0) >> 4),
    C2: ((data[9] & 0x0f) << 8) | data[10],
  }

  return {
    flagRicInConfigMode,
    flagInScheduleStartupMode,
    flagPowerIsBelowShutdownLevel,
    flagPowerIsBelowWarningLevel,
    temperature,
    sensorReadings,
  }
}
